module.exports = __webpack_public_path__ + "img/13.70a29652.jpg";